import { useState, useCallback } from 'react';

export const useAddProducts = (initialLookProducts = []) => {
  const [productsToAdd, setProductsToAdd] = useState(initialLookProducts);

  const addProduct = useCallback((parentProduct, childProduct) => {
    setProductsToAdd((prev) => {
      const parentIndex = prev.findIndex((p) =>
        p.new
          ? p.uid === parentProduct.uid
          : p.child_products[0]?.parent_product?.uid === parentProduct.uid,
      );

      if (parentIndex === -1) {
        return [
          ...prev,
          { ...parentProduct, child_products: [{ ...childProduct, new: true }], new: true },
        ];
      }

      const updatedParent = { ...prev[parentIndex] };
      if (!updatedParent.child_products.some((c) => c.uid === childProduct.uid)) {
        updatedParent.child_products = [
          ...updatedParent.child_products,
          { ...childProduct, new: true },
        ];
      }

      const updatedProducts = [...prev];
      updatedProducts[parentIndex] = updatedParent;
      return updatedProducts;
    });
  }, []);

  const removeProduct = useCallback((parentUid, childUid) => {
    setProductsToAdd((prev) => {
      const parentIndex = prev.findIndex((p) => p.uid === parentUid);
      if (parentIndex === -1) return prev;

      const parent = { ...prev[parentIndex] };
      const filteredChildren = parent.child_products.filter((c) => c.uid !== childUid);

      if (!filteredChildren.length) {
        const updated = [...prev];
        updated.splice(parentIndex, 1);
        return updated;
      }

      const updated = [...prev];
      updated[parentIndex] = { ...parent, child_products: filteredChildren };
      return updated;
    });
  }, []);

  const reset = useCallback(() => {
    setProductsToAdd([]);
  }, []);

  return {
    productsToAdd,
    addProduct,
    removeProduct,
    reset,
  };
};
